import React from "react";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Form,
    FormGroup,
    Input,
    Label,
    Table,
    Row,
    Col
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine"
import CoreEngine from "../../core/CoreEngine";

import ImageUpload from "../../components/CustomUpload/ImageUpload";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";

import FormRow from "../../components/Row/FormRow"
import SelectRow from "../../components/Select/SelectRow"
import { AvForm } from 'availity-reactstrap-validation';

import Constants from "../../core/Constants";

export default class CategoryarticleAddUpdate extends CoreEngine {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            name:"",
            description:"",
            _id:"",
            fullpicture:"",
            picture:"",
            parent:"",
            categorylist:[],
            loading : false
        };
        this.pathname = "articlecategory";
        this.engine = new RequestEngine();
    }

    componentDidMount() {
        const edit = this.props.location.data
        if (edit){
            this.setState({
                ...edit,
                fullpicture:edit.picture.length>1 ? Constants.serverlink+"/upload/"+edit.picture:"",
                parent:edit.category && edit.category._id
            },()=>this.prepareData());
        }else{
            this.prepareData()
        }
    }

    async prepareData(){
        let responseuni = await this.engine.getItemlistDirect("articlecategory");
        const {_id} = this.state
        if(responseuni){
            const data = responseuni.data.data;
            let categorylist = []
            categorylist.push( { value: "", label: "No Parent"})
            data.map(p =>{
                    if(_id!=p._id){
                        categorylist.push( { value: p._id, label: p.name})
                    }
                }
            )

            this.setState({
                categorylist: categorylist
            });
        }
    }


    handleValidSubmit = async () => {


        this.setState({
            loading: true
        })


        const {  _id,name,description,picture ,parent}= this.state;

        const formData = new FormData();
        formData.append('picture',picture)
        formData.append('_id',_id)
        formData.append('name',name)
        formData.append('parent',parent)
        formData.append('description',description)

        const response = await this.engine.saveItemData(this.pathname,formData)

        if(response && response.status === 200){
            this.props.history.push('/admin/'+this.pathname);
        }
        this.setState({
            loading: false
        })

    };

    onChangePic(e) {
        this.setState({picture:e.target.files[0]})
    }
    render() {
        // taking all the states
        const {loading,isLoading, categorylist, name,description,parent }= this.state;

        if (isLoading) {
            return this.renderProgress()
        }
        return (
            <>
                <div className="content english">

                    <h4></h4>
                    <Row>
                        <Col md="12">

                            <AvForm  onValidSubmit={() =>this.handleValidSubmit()} className="form-horizontal" id="TypeValidation">
                                <Card>
                                    <CardHeader>
                                        <CardTitle tag="h4">Information</CardTitle>
                                    </CardHeader>
                                    <CardBody>
                                        <FormRow label="Title" name="name" data={name}   changeInput={this.changeInput.bind(this)} />
                                        <SelectRow label="Parent category"  name="parent"  defaultValue={parent}  data={categorylist} changeInput={this.changeInput.bind(this)} />
                                        <FormRow required={false} label="description" name="description" type={"textarea"} data={description} changeInput={this.changeInput.bind(this)}  />

                                        <Row>
                                            <Label sm="2">Image</Label>
                                            <Col sm="5">
                                                <FormGroup >
                                                    <ImageUpload placeholder={this.state.fullpicture} labelupload="Select Image" onChange={(e) => this.onChangePic(e)}/>
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                    </CardBody>







                                    <CardFooter className="text-center">
                                        <ButtonLoader color="primary" loading={loading}>Save</ButtonLoader>
                                    </CardFooter>
                                </Card>
                            </AvForm>

                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}


